import { CountyService } from './services/county/county.service';
import { CommonService } from './services/common/common.service';
import { AuthLoginGuard } from './guard/auth-login.guard';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

// Modules
import { SharedModule } from './shared/shared.module';

// Routing Module
import { AppRoutingModule } from './app.routing';

// Interceptor
import { CommonHttpInterceptor } from './interceptor/common.interceptor';

// Services
import { HelperService } from './services/helper-service/helper.service';
import { ApiService } from './services/api-service/api.service';

// Directives

// Components
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import { UserService } from './services/user/user.service';
// import { CreateProfileComponent } from './page/create-profile/create-profile.component';

@NgModule({
  imports: [
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    FormsModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CommonModule,
    SharedModule,
    AppRoutingModule
  ],
  declarations: [
    AppComponent
  ],
  providers: [
    CommonService,
    CountyService,
    AuthLoginGuard,
    HelperService,
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: CommonHttpInterceptor,
    },
    ApiService,
    FormBuilder,
    UserService
  ],
  bootstrap: [AppComponent]
})

export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts